import type { ReactNode } from 'react';

import Link from 'next/link';

import type { TFunction } from 'i18next';

import { MAKE_MAIN_URL, MAKE_SPRAVOCHNIY_CENTR_LINK } from '@/constants/routes';

export type AnswerAndQuestion = {
	question: string;
	answer?: string;
	node?: ReactNode;
};

export const getAnswerAndQuestions = (t: TFunction): AnswerAndQuestion[] => [
	{
		question: t('about-us-container.faq.audience.question'),
		answer: t('about-us-container.faq.audience.answer'),
	},
	{
		question: t('about-us-container.faq.benefits.question'),
		answer: t('about-us-container.faq.benefits.answer'),
	},
	{
		question: t('about-us-container.faq.getting-started.question'),
		answer: t('about-us-container.faq.getting-started.answer'),
	},
	{
		question: t('about-us-container.faq.fish-company-cost.question'),
		node: (
			<div>
				{t('about-us-container.faq.fish-company-cost.answer')}{' '}
				<Link href={MAKE_MAIN_URL('tariffs')} target="_blank">
					{t('about-us-container.faq.fish-company-cost.link')}
				</Link>
			</div>
		),
	},
	{
		question: t('about-us-container.faq.warehouse-cost.question'),
		answer: t('about-us-container.faq.warehouse-cost.answer'),
	},
	{
		question: t('about-us-container.faq.inactive-subscription.question'),
		answer: t('about-us-container.faq.inactive-subscription.answer'),
	},
	{
		question: t('about-us-container.faq.strategic-partner.question'),
		answer: t('about-us-container.faq.strategic-partner.answer'),
	},
	{
		question: t('about-us-container.faq.strategic-benefits.question'),
		answer: t('about-us-container.faq.strategic-benefits.answer'),
	},
	{
		question: t('about-us-container.faq.technology.question'),
		node: (
			<div>
				{t('about-us-container.faq.technology.answer')}{' '}
				<Link href={MAKE_SPRAVOCHNIY_CENTR_LINK('importantDocument')}>
					{t('about-us-container.faq.technology.link')}
				</Link>
			</div>
		),
	},
	{
		question: t('about-us-container.faq.support.question'),
		node: (
			<div>
				{t('about-us-container.faq.support.answer')}{' '}
				<Link href={MAKE_SPRAVOCHNIY_CENTR_LINK()}>{t('about-us-container.faq.support.link')}</Link>
			</div>
		),
	},
];
